<template>
  <div>
    <div class="component-roomtypes">
      <div class="panel position-relative panel-content">
        <Breadcrumb :items=breadCrumbs() v-if="loaded"/>
        <div class="list d-none d-md-block left-edge">
          <div class="position-relative-w-100">
            <p class="txt-red">
              {{ $t('pages.search-page.search-result') }}
              <span class="bold txt-bold">{{ search }}</span>
            </p>
          </div>
          <p class="head-line justify-content-between mt-3">
            <span>{{ $t('pages.project-key.title') }}</span>
            <spinner v-if="!loaded"/>
          </p>
          <div class="plans-table mb-2" v-if="loaded">
            <table class="w-100">
              <thead>
                <tr>
                  <th class="w-id">{{ $t('id') }}</th>
                  <th class="w-name">{{ $t('pages.project-key.headers.key') }}</th>
                  <th class="w-name" v-if="!isAdmin && user.language.name !== null">
                    {{ user.language.name + ' ' + $t('pages.project-translations.headers.translation') }}
                  </th>
                  <th class="w-name" v-else>
                    {{ $t('pages.project-translations.headers.translation') }}
                  </th>
                  <th class="w-occupancy text-center">{{ $t('pages.project-key.headers.description') }}</th>
                  <th class="w-actions">{{ $t('actions') }}</th>
                </tr>
              </thead>

              <tbody v-if="keywordsResults.length === 0">
                <tr>
                  <td colspan="5" class="w-empty">{{ $t('pages.project-key.no-project-key') }}</td>
                </tr>
              </tbody>
              <tbody v-for="row in keywordsResults" :key="row.typesenseId">
                <tr class="separator before"></tr>
                <tr>
                  <td>
                    {{ row.id }}
                  </td>
                  <td>
                    <p>{{ row.key }}</p>
                  </td>
                  <td>
                    {{ row.translation }}
                  </td>
                  <td class="text-center">
                    {{ row.description }}
                  </td>
                  <td class="actions">
                    <b-btn  v-if="isAdmin || isDeveloper"
                            class="btn-icon btn-tiny"
                            @click="projectKeysUrl(row.project_page_id)">
                      <icon width="19" height="19" type="connect"
                            v-b-tooltip:page-channels.bottom="$t('pages.project-page.tooltips.keys')"
                      />
                    </b-btn>
                    <b-btn v-if="isAdmin || isTranslator"
                           class="btn-icon btn-tiny"
                           @click="projectTranslationsUrlWithSearch(row)"
                    >
                      <icon width="19" height="19" type="globe"
                            v-b-tooltip:page-channels.bottom="$t('pages.project-page.tooltips.translations')"
                      />
                    </b-btn>
                  </td>
                </tr>
                <tr class="separator after"></tr>
              </tbody>
            </table>
            <spinner v-if="isLoadedMoreData"/>
          </div>
          <p class="head-line justify-content-between">
            <span>{{ $t('pages.projects.title') }}</span>
            <spinner v-if="!loaded"/>
          </p>
          <div class="plans-table mb-2" v-if="loaded">
            <table class="w-100">
              <thead>
                <tr>
                  <th class="w-id">{{ $t('id') }}</th>
                  <th class="w-id">{{ $t('pages.projects.headers.key') }}</th>
                  <th class="w-name">{{ $t('pages.projects.headers.name') }}</th>
                  <th class="w-occupancy text-center">{{ $t('pages.projects.headers.description') }}</th>
                  <th class="w-actions">{{ $t('actions') }}</th>
                </tr>
              </thead>

              <tbody v-if="projectsResults.length === 0 && loaded">
                <tr class="separator before"></tr>
                <tr>
                  <td colspan="5" class="w-empty">{{ $t('pages.projects.no-projects') }}</td>
                </tr>
                <tr class="separator after"></tr>
              </tbody>
              <tbody v-for="row in projectsResults" :key="row.id">
                <tr class="separator before"></tr>
                <tr>
                  <td>
                    {{ row.id }}
                  </td>
                  <td>
                    {{ row.key }}
                  </td>
                  <td>
                    <p>{{ row.name }}</p>
                  </td>
                  <td class="text-center">
                    {{ row.description }}
                  </td>
                  <td class="actions">
                    <b-btn v-if="isAdmin || isDeveloper"
                           class="btn-icon btn-tiny" @click="projectPageUrl(row.id)"
                    >
                      <icon width="19" height="19" type="connect"
                            v-b-tooltip:page-channels.bottom="$t('pages.projects.tooltips.project-page')"
                      />
                    </b-btn>
                    <b-btn
                      v-if="isAdmin || isTranslator"
                      class="btn-icon btn-tiny" @click="projectTranslationsUrl(row.id)">
                      <icon width="19" height="19" type="globe"
                            v-b-tooltip:page-channels.bottom="$t('pages.projects.tooltips.project-all-translations')"
                      />
                    </b-btn>
                  </td>
                </tr>
                <tr class="separator after"></tr>
              </tbody>
            </table>
          </div>
          <p class="head-line justify-content-between mt-3">
            <span>{{ $t('pages.project-page.title') }}</span>
            <spinner v-if="!loaded"/>
          </p>
          <div class="plans-table" v-if="loaded">
            <table class="w-100">
              <thead>
                <tr>
                  <th class="w-id">{{ $t('id') }}</th>
                  <th class="w-name">{{ $t('pages.project-page.headers.key') }}</th>
                  <th class="w-occupancy text-center">{{ $t('pages.project-page.headers.name') }}</th>
                  <th class="w-actions">{{ $t('actions') }}</th>
                </tr>
              </thead>

              <tbody v-if="pagesResults.length === 0">
                <tr>
                  <td colspan="4" class="w-empty">{{ $t('pages.project-page.no-project-page') }}</td>
                </tr>
              </tbody>
              <tbody v-for="row in pagesResults" :key="row.id">
                <tr class="separator before"></tr>
                <tr>
                  <td>
                    {{ row.id }}
                  </td>
                  <td>
                    <p>{{ row.key }}</p>
                  </td>
                  <td>
                    {{ row.name }}
                  </td>
                  <td class="actions">
                    <b-btn v-if="isAdmin || isDeveloper"
                           class="btn-icon btn-tiny" @click="projectKeysUrl(row.id)">
                      <icon width="19" height="19" type="connect"
                            v-b-tooltip:page-channels.bottom="$t('pages.project-page.tooltips.keys')"
                      />
                    </b-btn>
                    <b-btn v-if="isAdmin || isTranslator" class="btn-icon btn-tiny"
                           @click="projectPageViewUrl(row.id)"
                    >
                      <icon width="19" height="19" type="globe"
                            v-b-tooltip:page-channels.bottom="$t('pages.project-page.tooltips.translations')"
                      />
                    </b-btn>
                  </td>
                </tr>
                <tr class="separator after"></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';

  export default {
    name: 'SearchPage',
    data: () => ({
      search: null,
      currentPage: 1,
      isLoadedMoreData: false,
    }),
    async created() {
      if (!this.$route.query.q) {
        await this.$router.push({ name: 'dashboard' });
      }
      this.search = this.$route.query.q;
      await this.show();
    },
    computed: {
      ...mapGetters('search', ['loaded', 'searchResults']),
      ...mapState('search', ['error', 'pending', 'updatePending']),
      ...mapGetters('user', ['user', 'isAdmin', 'isDeveloper', 'isTranslator']),

      projectsResults() {
        return this.searchResults?.projects?.data ?? [];
      },
      pagesResults() {
        return this.searchResults?.pages?.data?.items ?? [];
      },
      keywordsResults() {
        return this.searchResults?.keywords?.data?.items ?? [];
      },
      keywordsCount() {
        return this.searchResults?.keywords?.data?.totalRows ?? null;
      },
    },
    methods: {
      ...mapActions('search', ['fetchData', 'searchRecords', 'loadMoreKeywords', 'readyLoadMoreKeywords']),
      async show() {
        // Fetched from Typesense
        await this.searchRecords({
          q: this.search,
          userRole: this.user.role_key,
          userProjects: this.user.projects,
          userLanguage: this.user.language,
        });
        // Fetched from Backend API
        // await this.fetchData({
        //   search: this.search,
        // });
      },
      breadCrumbs() {
        return [
          {
            text: this.$t('pages.dashboard.title'),
            to: { name: 'dashboard' },
          },
          {
            text: this.$t('pages.search-page.title'),
            active: true,
          },
        ];
      },
      projectPageUrl(projectId) {
        this.$router.push({
          name: 'projects-pages',
          params: { id: projectId },
        });
      },
      projectPageViewUrl(projectPageId) {
        this.$router.push({
          name: 'projects-translations',
          params: { id: projectPageId },
        });
      },
      projectTranslationsUrl(projectId) {
        this.$router.push({
          name: 'projects-all-translations',
          params: { id: projectId },
        });
      },
      projectTranslationsUrlWithSearch(row) {
        const query = {
          q: row.translation.slice(0, 20),
          iso: row.languageIso,
        };

        this.$router.push({
          name: 'projects-all-translations',
          params: { id: row.projectId },
          query,
        });
      },
      projectKeysUrl(projectId) {
        this.$router.push({
          name: 'projects-keys',
          params: { id: projectId },
        });
      },
      async loadMore() {
        this.isLoadedMoreData = true;
        await this.readyLoadMoreKeywords({
          readyToLoad: false,
        });
        this.currentPage += 1;
        const response = await this.loadMoreKeywords({
          q: this.search,
          userRole: this.user.role_key,
          userProjects: this.user.projects,
          userLanguage: this.user.language,
          forPage: this.currentPage,
        });

        this.isLoadedMoreData = false;
        this.keywordsResults.push(
          ...response.items,
        );
        await this.readyLoadMoreKeywords({
          readyToLoad: true,
        });
      },
    },
    watch: {
      $route() {
        if (this.search !== this.$route.query.q) {
          this.search = this.$route.query.q;
          this.show();
        }
        if (this.$route.query.q && this.$route.query.page) {
          this.loadMore();
        }
      },
    },
  };
</script>
